<div id="donut{{index}}" #donut class="donut{{index}}">
    <p *ngIf="!donutData.length" class="mt">No Data</p>
</div>